/** @jsxImportSource @emotion/react */
import { memo } from "react";
import PropTypes from "prop-types";
import { Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewer = memo(({ fileUrl }) => (
  <div
    style={{
      width: "100%",
      height: "100%",
      minHeight: "300px",
      borderRadius: "0",
    }}
  >
    <Viewer fileUrl={fileUrl} />
  </div>
));

PdfViewer.displayName = "PdfViewer";

PdfViewer.propTypes = {
  fileUrl: PropTypes.string.isRequired,
};

export default PdfViewer;
